<template>
    <div id="try-again" class="page">

        <div class="head-wrapper">
          <h2 class="in">Try Again <span>Next Time!</span></h2>
        </div>

        <div class="stage-wrapper">
          <div class="egg-spacer"></div>

            <p v-if="hasFailure" class="sub-copy in">Check back soon for another chance to win!</p>

            <p v-else class="sub-copy in">You've already checked to see if you've won today.</p>

        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TryAgain',

  computed: {
    ...mapGetters([
      'hasFailure',
    ]) 
  
  },
}
</script>

<style>

</style>